import React from 'react';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import Modal from '../../../../../Components/Modal/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import PatientDataVerificationVZPResult, {
	PatientDataVerificationVZPResultExtra,
} from './PatientDataVerificationVZPResult';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	extra: PatientDataVerificationVZPResultExtra;
}

const PatientDataVerificationVZPResultModal: React.FC<Props> = ({
	isOpen,
	onClose,
	extra,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.SM}>
			<Modal.Header title='component.patientDataVerificationVZPResult.modalTitle' />
			<Modal.Content contentScroll>
				<PatientDataVerificationVZPResult extra={extra} onClick={onClose} />
			</Modal.Content>
		</Modal>
	);
};

export default PatientDataVerificationVZPResultModal;
